import {
  fetchAppStoreReviews as fetchAppStoreReviewsFromApi,
  fetchPlayStoreReviews as fetchPlayStoreReviewsFromApi,
  fetchOriginationCountries as fetchOriginationCountriesFromApi,
  fetchCountries as fetchCountriesFromApi,
  searchCallingCorridors as searchCallingCorridorsInApi,
  fetchPriceLeaderCountries as fetchPriceLeaderCountriesFromApi
} from '@/api/competitor'

const fetchAppStoreReviews = async ({commit}) => {
  let response = await fetchAppStoreReviewsFromApi()
  commit('SET_APPS', response)
}

const fetchPlayStoreReviews = async ({commit}) => {
  let response = await fetchPlayStoreReviewsFromApi()
  commit('SET_APPS', response)
}

const fetchOriginationCountries = async ({commit}) => {
  let response = await fetchOriginationCountriesFromApi()
  commit('SET_ORIGINATION_COUNTRIES', response)
}

const fetchCountries = async ({commit}) => {
  let response = await fetchCountriesFromApi()
  commit('SET_COUNTRIES', response)
}

const searchCallingCorridors = async ({commit}, payload) => {
  let response = await searchCallingCorridorsInApi(payload)
  commit('SET_CALLING_CORRIDORS', response)
}

const clearCallingCorridors = ({commit}) => {
  commit('SET_CALLING_CORRIDORS', null)
}

const fetchPriceLeaderCountries = async ({commit}, origination) => {
  let response = await fetchPriceLeaderCountriesFromApi(origination)
  commit('SET_CALLING_CORRIDORS', response)
}

export default {
  fetchAppStoreReviews,
  fetchPlayStoreReviews,
  fetchOriginationCountries,
  fetchCountries,
  searchCallingCorridors,
  fetchPriceLeaderCountries,
  clearCallingCorridors
}



// WEBPACK FOOTER //
// ./src/store/modules/competitor/actions.js